import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileSticky from "../components/MobileSticky";
import QuoteForm from "../components/QuoteForm";
import Seo from "../components/Seo";

export default function Quote() {
  return (
    <div data-testid="page-quote">
      <Seo
        title="Get a Quote — Connolly's Painting Solutions"
        description="Free quote today quote for painting on the Sunshine Coast. Interior, exterior, roof, commercial and specialty finishes. We respond within one business day."
        path="/quote"
      />
      <Header />

      <section className="section bg-[#F9F8F6]">
        <div className="container-cps max-w-4xl">
          <div className="overline">Free quote</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Start your project.</h1>
          <p className="mt-6 text-[#4F5B6A] max-w-2xl">
            The more detail you can give us — rooms, surfaces, photos, deadlines — the faster we can return a precise, fixed-price quote.
          </p>

          <div className="mt-12 bg-white p-8 md:p-12 border border-[#E5E3DB]">
            <QuoteForm sourcePage="quote" />
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </div>
  );
}
